import { render, staticRenderFns } from "./LegalPage.vue?vue&type=template&id=36a84e20"
import script from "./LegalPage.vue?vue&type=script&lang=js"
export * from "./LegalPage.vue?vue&type=script&lang=js"
import style0 from "./LegalPage.vue?vue&type=style&index=0&id=36a84e20&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports